<ng-template #loading_idealista>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>

<compass-idealista-form
  *ngIf="idealistaPois$ | async as idealistaPois; else loading_idealista"
  [poisTableList]="idealistaPois"
  style="width: 100%"
></compass-idealista-form>
